var _rect, _g, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShippingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.7,
    y: 0.70293,
    width: 28.6,
    height: 28.6,
    rx: 14.3,
    fill: "#E8F5FD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_672_33009)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.107 16.8936C18.7168 16.8936 17.5859 18.0245 17.5859 19.4146C17.5859 20.8047 18.7168 21.9356 20.107 21.9356C21.4973 21.9356 22.628 20.8047 22.628 19.4146C22.628 18.0245 21.4971 16.8936 20.107 16.8936ZM20.107 20.6751C19.4118 20.6751 18.8464 20.1097 18.8464 19.4146C18.8464 18.7194 19.4118 18.1541 20.107 18.1541C20.8021 18.1541 21.3675 18.7194 21.3675 19.4146C21.3675 20.1098 20.8021 20.6751 20.107 20.6751Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4898 16.8936C10.0996 16.8936 8.96875 18.0245 8.96875 19.4146C8.96875 20.8047 10.0996 21.9356 11.4898 21.9356C12.8799 21.9356 14.0108 20.8047 14.0108 19.4146C14.0108 18.0245 12.8799 16.8936 11.4898 16.8936ZM11.4898 20.6751C10.7946 20.6751 10.2293 20.1097 10.2293 19.4146C10.2293 18.7194 10.7946 18.1541 11.4898 18.1541C12.1847 18.1541 12.7503 18.7194 12.7503 19.4146C12.7503 20.1098 12.1849 20.6751 11.4898 20.6751Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8045 9.67813C21.6973 9.46531 21.4795 9.33105 21.2412 9.33105H17.9219V10.5916H20.8525L22.5687 14.005L23.6952 13.4386L21.8045 9.67813Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2142 18.8057H13.4453V20.0662H18.2142V18.8057Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.60023 18.8057H7.41539C7.06727 18.8057 6.78516 19.0878 6.78516 19.4359C6.78516 19.784 7.0673 20.0661 7.41539 20.0661H9.60027C9.9484 20.0661 10.2305 19.784 10.2305 19.4359C10.2305 19.0878 9.94836 18.8057 9.60023 18.8057Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8671 14.9527L23.6274 13.356C23.5083 13.2022 23.3245 13.1123 23.1297 13.1123H18.5498V8.70055C18.5498 8.35242 18.2677 8.07031 17.9196 8.07031H7.41539C7.06727 8.07031 6.78516 8.35246 6.78516 8.70055C6.78516 9.04863 7.0673 9.33078 7.41539 9.33078H17.2893V13.7425C17.2893 14.0907 17.5715 14.3728 17.9196 14.3728H22.8211L23.7389 15.5551V18.8055H21.9952C21.6471 18.8055 21.365 19.0877 21.365 19.4358C21.365 19.7839 21.6471 20.066 21.9952 20.066H24.3691C24.7173 20.066 24.9994 19.7839 24.9994 19.4358V15.3392C24.9994 15.1993 24.9528 15.0632 24.8671 14.9527Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.56066 15.6123H6.66148C6.31336 15.6123 6.03125 15.8945 6.03125 16.2425C6.03125 16.5907 6.3134 16.8728 6.66148 16.8728H9.56063C9.90875 16.8728 10.1909 16.5906 10.1909 16.2425C10.1909 15.8945 9.90875 15.6123 9.56066 15.6123Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0084 13.1328H5.63023C5.28215 13.1328 5 13.415 5 13.7631C5 14.1112 5.28215 14.3933 5.63023 14.3933H11.0084C11.3565 14.3933 11.6386 14.1112 11.6386 13.7631C11.6386 13.415 11.3565 13.1328 11.0084 13.1328Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0396 10.6543H6.66148C6.31336 10.6543 6.03125 10.9364 6.03125 11.2845C6.03125 11.6327 6.3134 11.9148 6.66148 11.9148H12.0396C12.3878 11.9148 12.6699 11.6326 12.6699 11.2845C12.6699 10.9364 12.3878 10.6543 12.0396 10.6543Z",
    fill: "#4D4D4D"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.7,
    y: 0.70293,
    width: 28.6,
    height: 28.6,
    rx: 14.3,
    stroke: "#4D4D4D",
    strokeWidth: 1.4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_672_33009"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(5 5.00293)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShippingIcon);
export default __webpack_public_path__ + "static/media/shipping-icon.0373042d905e383ae1b850bd9f0a8e30.svg";
export { ForwardRef as ReactComponent };